module.exports = __webpack_public_path__ + "static/media/5a_website_logo_diamond_Alliance.707ac676.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5a_website_logo_diamond_Alliance.jpg
// module id = 85
// module chunks = 0